import { useEffect, useState } from 'react';
import { navigationRef } from '../navigation/rootNavigation';

/**
 * CORE-498 — current top-level route name, kept live via the navigation ref.
 * Used by the Agapella launcher to hide itself on the full-chat screen.
 * Returns undefined until navigation is ready.
 */
export function useCurrentRouteName(): string | undefined {
  const [name, setName] = useState<string | undefined>(
    () => (navigationRef.isReady?.() ? navigationRef.getCurrentRoute()?.name : undefined),
  );

  useEffect(() => {
    // Guard getCurrentRoute() behind isReady(): the widget mounts as a SIBLING
    // of the NavigationContainer (App.tsx), so this effect can run before the
    // container attaches the ref. Calling getCurrentRoute() then logs «The
    // 'navigation' object hasn't been initialized yet» (fires on native too,
    // where the widget renders null but the hook still runs). addListener('state')
    // is buffered safely by the container ref and re-fires read() once ready.
    const read = () => {
      if (navigationRef.isReady?.()) setName(navigationRef.getCurrentRoute()?.name);
    };
    // Initial read once ready, then on every navigation state change.
    read();
    const unsub = navigationRef.addListener?.('state', read);
    return () => {
      unsub?.();
    };
  }, []);

  return name;
}
